import { Http } from '@angular/http';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ApiUrlConstants } from '../../common/constants/api.constants';
import { CacheKey } from '../../shared/constants/cachekey.constants';
import { CacheService } from '../../shared/services/cache.service';
import { AnonymousRetailSalesConstants } from '../constants/anonymous-retail-orders.constants';
var AnonymousRetailOrderService = /** @class */ (function () {
    function AnonymousRetailOrderService(_http, _cacheService) {
        this._http = _http;
        this._cacheService = _cacheService;
    }
    AnonymousRetailOrderService.prototype.handleErrorObservable = function (error) {
        return Observable.throw(error);
    };
    /**
     *
     * @param retailBonusObj
     * get Retail bonus sales record based on retailbonusObj param
     */
    AnonymousRetailOrderService.prototype.getRetailBonusSales = function (retailBonusObj) {
        var url = ApiUrlConstants.reportTitanBaseApiUrl + 'v1/anonymous-retail-sales?';
        url = url + (retailBonusObj.pageNumber ? 'pageNumber=' + retailBonusObj.pageNumber : 'pageNumber=' + AnonymousRetailSalesConstants.PageNumber);
        url = url + (retailBonusObj.pageSize ? '&numberOfRecords=' + retailBonusObj.pageSize : '&numberOfRecords=' + AnonymousRetailSalesConstants.PageSize);
        url = url + (retailBonusObj.sort ? '&sortOption=' + retailBonusObj.sort : '&sortOption=' + AnonymousRetailSalesConstants.DESC);
        if (retailBonusObj.storeID) {
            url = url + '&storeid=' + retailBonusObj.storeID;
        }
        if (retailBonusObj.sortColumn) {
            url = url + '&sortColumn=' + retailBonusObj.sortColumn;
        }
        if (retailBonusObj.year) {
            url = url + '&year=' + retailBonusObj.year;
        }
        if (retailBonusObj.month) {
            url = url + '&month=' + retailBonusObj.month;
        }
        return this._http
            .get(url)
            .pipe(map(function (res) { return res.json(); }), catchError(this.handleErrorObservable));
    };
    /**
     *
     * @param createRetailSalesObj
     * Create Retail bonus sales record based on createRetailSalesObj param
     */
    AnonymousRetailOrderService.prototype.createRetailBonusSales = function (createRetailSalesObj) {
        var url = ApiUrlConstants.manageAccountApiGwUrl + 'anonymous-retail-sales';
        return this._http
            .post(url, createRetailSalesObj)
            .pipe(map(function (res) { return res.json(); }), catchError(this.handleErrorObservable));
    };
    /**
     *
     * @param RetailSalesObj
     * Update Retail bonus sales record based on RetailSalesObj param
     */
    AnonymousRetailOrderService.prototype.updateOrDeleteRetailBonusSales = function (RetailSalesObj, isDelete) {
        var url = ApiUrlConstants.manageAccountApiGwUrl + 'anonymous-retail-sales/' + RetailSalesObj.id + '?isDelete=' + isDelete + '&updatedBy=' + RetailSalesObj.updatedBy;
        return this._http
            .put(url, RetailSalesObj)
            .pipe(map(function (res) { return res.json(); }), catchError(this.handleErrorObservable));
    };
    /**
     * get store details based on required month and year
     * @param month
     * @param year
     */
    AnonymousRetailOrderService.prototype.getStoreDetails = function (month, year) {
        var url = ApiUrlConstants.reportTitanBaseApiUrl + 'v1/anonymous-retail-sales/stores?processingMonth=' + month + '&processingYear=' + year;
        return this._http
            .get(url)
            .pipe(map(function (res) { return res.json(); }), catchError(this.handleErrorObservable));
    };
    /**
     * get retail participating stores
     */
    AnonymousRetailOrderService.prototype.getRetailParticipatingStores = function () {
        var url = ApiUrlConstants.configurationApiUrl + 'stores/retail-participating-stores';
        return this._http
            .get(url)
            .pipe(map(function (res) { return res.json(); }), catchError(this.handleErrorObservable));
    };
    /**
     *
     * @param salesID
     * @param createdBy
     *
     */
    AnonymousRetailOrderService.prototype.calculateOrderTotalCC = function (reqObj) {
        var url = ApiUrlConstants.batchApiUrl + 'file-upload';
        return this._http
            .post(url, reqObj)
            .pipe(map(function (res) { return res.json(); }), catchError(this.handleErrorObservable));
    };
    AnonymousRetailOrderService.prototype.approveRetailOrder = function (salesID, createdBy) {
        var url = ApiUrlConstants.batchApiUrl + 'anonymous-retail-sales/approve/' + salesID + '?createdBy=' + createdBy;
        return this._http
            .post(url, {})
            .pipe(map(function (res) { return res.json(); }), catchError(this.handleErrorObservable));
    };
    AnonymousRetailOrderService.prototype.reviseRetailOrder = function (salesID, revisedBy) {
        var url = ApiUrlConstants.accountApiUrl + 'anonymous-retail-sales/revise/' + salesID + '?revisedBy=' + revisedBy;
        return this._http
            .get(url)
            .pipe(map(function (res) { return res.json(); }), catchError(this.handleErrorObservable));
    };
    /**
     * check user has anonymous retail permissions
     * @param hasAnonymousRetailOrderPermission
     */
    AnonymousRetailOrderService.prototype.getAnonymousRetailAccess = function (hasAnonymousRetailOrderPermission) {
        var userInfo = this._cacheService.get(CacheKey.UserInfo);
        var isAllowed = false;
        if (userInfo && userInfo.hasSystemRole)
            return isAllowed = true;
        if (userInfo && userInfo.privileges && userInfo.privileges.stores && userInfo.privileges.stores.length > 0) {
            var userStorePermissions = userInfo.privileges.stores;
            var _loop_1 = function (i) {
                userStorePermissions.some(function (store) { return isAllowed = store.permissions.includes(hasAnonymousRetailOrderPermission[i]); });
                if (isAllowed)
                    return "break";
            };
            for (var i = 0; i < hasAnonymousRetailOrderPermission.length; i++) {
                var state_1 = _loop_1(i);
                if (state_1 === "break")
                    break;
            }
        }
        return isAllowed;
    };
    AnonymousRetailOrderService.prototype.getUsersDetails = function (userIds) {
        var url = ApiUrlConstants.enrollmentApigwUrl + 'user-details?userIds=' + userIds;
        return this._http
            .get(url)
            .pipe(map(function (res) { return res.json(); }), catchError(this.handleErrorObservable));
    };
    AnonymousRetailOrderService.prototype.getOrderdetails = function (anonymousRetailSalesId, pageSize, pageNumber) {
        var url = ApiUrlConstants.reportTitanBaseApiUrl + 'v1/anonymous-retail-sales/' + anonymousRetailSalesId + '/order-details?pageSize=' + pageSize + '&pageNumber=' + pageNumber;
        return this._http
            .get(url)
            .pipe(map(function (res) { return res.json(); }), catchError(this.handleErrorObservable));
    };
    AnonymousRetailOrderService.prototype.regenerateOrders = function (initiateOrder) {
        var url = ApiUrlConstants.batchApiUrl + 'anonymous-retail-sales/initiate-order';
        return this._http
            .post(url, initiateOrder)
            .pipe(map(function (res) { return res.json(); }), catchError(this.handleErrorObservable));
    };
    AnonymousRetailOrderService.prototype.getLogDetails = function (retailSalesId) {
        var url = ApiUrlConstants.accountApiUrl + 'anonymous-retail-sales/' + retailSalesId + '/log-details';
        return this._http
            .get(url)
            .pipe(map(function (res) { return res.json(); }), catchError(this.handleErrorObservable));
    };
    return AnonymousRetailOrderService;
}());
export { AnonymousRetailOrderService };



// WEBPACK FOOTER //
// ./src/app/customerservice/services/anonymous-retail-order.service.ts.pre-build-optimizer.js